"use client";

import { useEffect, useState } from "react";
import Image from "next/image";
import social from "@/assets/Image/comman/social.png";

export default function SocialIcon() {
  const [showSocialIcon, setShowSocialIcon] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowSocialIcon(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!showSocialIcon) return null;

  return (
    <div className="fixed bottom-4 end-5 sm:end-10 z-30">
      <a
        href="https://wa.me/919978604488?text=Hello" target="_blank"
        rel="noopener noreferrer">
        <Image src={social} alt="social" className="w-12 h-12" />
      </a>
    </div>
  );
}
